import { api } from '../middleware/api';

// Define endpoints using injectApi pattern
export const stateApi = api
  .enhanceEndpoints({ addTagTypes: ['State'] })
  .injectEndpoints({
    endpoints: builder => ({
      getStates: builder.query<(bt_mstate & bt_mcountry)[], void>({
        query: () => `state/`,
        providesTags: ['State']
      }),
      getStates1: builder.query<(bt_mstate & bt_mcountry)[], void>({
        query: () => `state/1`,
        providesTags: ['State']
      }),
      getStatesByCountry: builder.query<(bt_mstate & bt_mcountry)[], any>({
        query: country => `state/bycountry/${country}`,
        providesTags: ['State']
      }),
      getStateById: builder.query<bt_mstate, string>({
        query: id => `state/byid/${id}`,
        providesTags: ['State']
      }),
      getStateByCode: builder.query<bt_mstate, string>({
        query: code => `state/code/${code}`,
        providesTags: ['State']
      }),
      insertState: builder.mutation({
        query: state => ({
          url: `state/`,
          method: 'POST',
          body: state
        }),
        invalidatesTags: ['State']
      }),
      updateState: builder.mutation({
        query: state => ({
          url: `state/`,
          method: 'PUT',
          body: state
        }),
        invalidatesTags: ['State']
      }),
      deleteState: builder.mutation({
        query: state => ({
          url: `state/${state.st_id}`,
          method: 'DELETE'
        }),
        invalidatesTags: ['State']
      })
    }),
    overrideExisting: false
  });

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetStatesQuery,
  useGetStates1Query,
  useGetStateByIdQuery,
  useGetStatesByCountryQuery,
  useGetStateByCodeQuery,
  useInsertStateMutation,
  useUpdateStateMutation,
  useDeleteStateMutation
} = stateApi;

